import React from 'react';

interface NoFoundTasksProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const NoFoundTasks = ({ fill = '#C1C4C9', width = 24, height = 24 }: NoFoundTasksProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={`${width}`}
        height={`${height}`}
        viewBox="0 0 24 24"
        fill="none"
    >
        <g clipPath="url(#clip0_3170_27365)">
            <path
                d="M23.973 22.5589L17.744 16.3299C19.2082 14.5477 20.0078 12.3123 20.006 10.0059C20.006 4.49186 15.52 0.00585938 10.006 0.00585938C4.492 0.00585938 0.0059967 4.49186 0.0059967 10.0059C0.0059967 15.5199 4.492 20.0059 10.006 20.0059C12.404 20.0059 14.606 19.1559 16.33 17.7439L22.559 23.9729L23.973 22.5589ZM10.006 18.0059C5.595 18.0059 2.006 14.4169 2.006 10.0059C2.006 5.59486 5.595 2.00586 10.006 2.00586C14.417 2.00586 18.006 5.59486 18.006 10.0059C18.006 14.4169 14.417 18.0059 10.006 18.0059ZM13.957 7.45686L11.414 9.99986L13.957 12.5429L12.543 13.9569L10 11.4139L7.457 13.9569L6.043 12.5429L8.586 9.99986L6.043 7.45686L7.457 6.04286L10 8.58586L12.543 6.04286L13.957 7.45686Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_3170_27365">
                <rect width={`${width}`} height={`${height}`} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
